export enum BimProjectCustomAttributeType {
    Text = "Text",
    Predefined = "Predefined",
}
